const assign = require('lodash/assign');
const get = require('lodash/get');
const keys = require('lodash/keys');
const reduce = require('lodash/reduce');

class FlowCartItem {
  constructor(item) {
    this.item = item;
  }

  getLocal() {
    return get(this.item, 'local');
  }

  getLocalizedProperties() {
    const local = this.getLocal();
    return reduce(keys(local), (properties, key) =>
      assign(properties, { [`flow_${key}_label`]: get(local, `${key}.label`) }), {});
  }
}

module.exports = FlowCartItem;



// WEBPACK FOOTER //
// ./static/js/v0/cart_unified/FlowCartItem.js